var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInventory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.1268 20.901H5.72877C5.38082 20.901 5.10742 20.6276 5.10742 20.2796V5.0066C5.10742 4.65865 5.38082 4.38525 5.72877 4.38525H23.1268C23.4748 4.38525 23.7482 4.65865 23.7482 5.0066V20.2796C23.7482 20.6276 23.4748 20.901 23.1268 20.901ZM6.35012 19.6583H22.5054V5.62795H6.35012V19.6583Z",
    fill: "#3D3C42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9829 1.8125L21.8964 4.385H6.92188L8.71137 1.8125H19.9829Z",
    fill: "#3D3C42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.624 4.63332C23.761 4.81982 23.7855 5.06832 23.686 5.27982C23.587 5.49082 23.363 5.62782 23.127 5.62782H5.72902C5.49302 5.62782 5.28152 5.50332 5.18202 5.29182C5.08252 5.08082 5.09502 4.84482 5.21952 4.64582L7.87902 0.830824C7.99052 0.669324 8.18952 0.569824 8.38852 0.569824H20.2935C20.4925 0.569824 20.679 0.656824 20.7905 0.818324L23.624 4.63332ZM21.8965 4.38482L19.983 1.81232H8.71152L6.92202 4.38482H21.8965Z",
    fill: "#3D3C42"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1271 23.0753C23.4751 23.0753 23.7486 23.3488 23.7486 23.6968C23.7486 24.0448 23.4751 24.3183 23.1271 24.3183H2.53506C2.18706 24.3183 1.91406 24.0448 1.91406 23.6968V5.00627C1.91406 4.65827 2.18706 4.38477 2.53506 4.38477C2.88306 4.38477 3.15656 4.65827 3.15656 5.00627V23.0753H23.1271Z",
    fill: "#3D3C42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6592 8.78418C18.0072 8.78418 18.2807 9.05718 18.2807 9.40518C18.2807 9.75318 18.0072 10.0267 17.6592 10.0267H10.4887C10.1407 10.0267 9.86719 9.75318 9.86719 9.40518C9.86719 9.05718 10.1407 8.78418 10.4887 8.78418H17.6592Z",
    fill: "#3D3C42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInventory);
export default __webpack_public_path__ + "static/media/ic_inventory.967259b629d6816f9b2fe893eee61df7.svg";
export { ForwardRef as ReactComponent };